module.exports = __webpack_public_path__ + "static/media/profile-2.2e63889b.svg";